module.exports = __webpack_public_path__ + "img/forever-link-lobby-login.eafdf505.png";